import Service from "../Service";
const resource = "SupplierApprovals/";

export default {
    save(ded, requestID) {
        return Service.post(resource + "save", ded, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    AttachmentList(suaID, requestID) {
        return Service.post(resource + "AttachmentList", {}, {
            params: {
                SuaID: suaID,
                requestID: requestID,
            },
        });
    },
    MarketList(suaID, requestID) {
        return Service.post(resource + "MarketList", {}, {
            params: {
                SuaID: suaID,
                requestID: requestID,
            },
        });
    },
    MaterialAnalysisList(suaID, requestID) {
        return Service.post(resource + "MaterialAnalysisList", {}, {
            params: {
                SuaID: suaID,
                requestID: requestID,
            },
        });
    },

    UpdateStatusApprovals(obj, requestID) {
        return Service.post(resource + "UpdateStatusApprovals", obj, {
            params: {
                requestID: requestID,
            },
        });
    },

    UpdateAttachmentStatus(obj, requestID) {
        return Service.post(resource + "UpdateAttachmentStatus", obj, {
            params: {
                requestID: requestID,
            },
        });
    },

    HarvestScheduleLots(CmaID, requestID) {
        return Service.post(resource + "HarvestScheduleLots", {}, {
            params: {
                CmaID: CmaID,
                requestID: requestID,
            },
        });
    },

    AvailableMaterialAnalysisList(cmaID, fltID, suaID, requestID) {
        return Service.post(resource + "AvailableMaterialAnalysisList", {}, {
            params: {
                CmaID: cmaID,
                FltID: fltID,
                SuaID: suaID || 0,
                requestID: requestID,
            },
        });
    },

    ProhibitedMarketsBySubstanceList(suaID, requestID) {
        return Service.post(resource + "ProhibitedMarketsBySubstanceList", {}, {
            params: {
                SuaID: suaID,
                requestID: requestID,
            },
        });
    },

    RegisterProhibitedMarkets(suaID, markets = [], requestID) {
        return Service.post(
            resource + "RegisterProhibitedMarkets",
            {
                SuaID: suaID,
                Markets: markets,
            },
            {
                params: {
                    requestID: requestID,
                },
            }
        );
    },
};